import axiosInstance from './api';

export const loginUser  = async (email, password) => {
  const payload = {
    user: {
      email,
      password,
    },
  };

  let axiosConfig = {
    headers: {
      'Access-Control-Allow-Origin': '*', 
      'Content-Type': 'application/json'
  }
  };

  try {
    const response = await axiosInstance.post('/login', payload , axiosConfig);
    const token = response.headers['authorization'] || response.headers['Authorization'];
    console.log(document.cookie);
    console.log(response);
    if (!token) {
      throw new Error('Token not found in response headers');
    }
    
    sessionStorage.removeItem('api_key');
    const data = response.data?.data;
    if (data?.api_key) {
      localStorage.setItem('api_key', data?.api_key);
      localStorage.setItem('user_id', data?.id);
      localStorage.setItem('first_name', data?.first_name);
      localStorage.setItem('last_name', data?.last_name);
    }

    // Store agent_integrations for blog generation flow
    // Priority: 1. Individual user agent_integrations, 2. Public agent_integrations (for missing keys)
    let agentIntegrationsToStore = {};
    
    // Start with public agent_integrations as base
    if (data?.public_agent_integrations?.agent_integrations) {
      agentIntegrationsToStore = { ...data.public_agent_integrations.agent_integrations };
    }
    
    // Override with individual user's agent_integrations (takes priority)
    if (data?.agent_integrations && Object.keys(data.agent_integrations).length > 0) {
      agentIntegrationsToStore = { ...agentIntegrationsToStore, ...data.agent_integrations };
    }
    
    // Only store if we have at least one integration
    if (Object.keys(agentIntegrationsToStore).length > 0) {
      localStorage.setItem('agent_integrations', JSON.stringify(agentIntegrationsToStore));
    }

    return { token, user: { email } }; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Login failed');
  }
};